var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLargeLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0241 5.92308C11.8277 3.08184 14.44 1 17.5385 1H22.4616C25.5601 1 28.1724 3.08184 28.976 5.92308H32.3077C36.0463 5.92308 39.0769 8.95376 39.0769 12.6923V42.2308C39.0769 45.9693 36.0463 49 32.3077 49H7.69233C3.95378 49 0.923096 45.9693 0.923096 42.2308V12.6923C0.923096 8.95376 3.95378 5.92308 7.69233 5.92308H11.0241ZM11.0241 9.61539H7.69233C5.99299 9.61539 4.6154 10.993 4.6154 12.6923V42.2308C4.6154 43.9301 5.99299 45.3077 7.69233 45.3077H32.3077C34.007 45.3077 35.3846 43.9301 35.3846 42.2308V12.6923C35.3846 10.993 34.007 9.61539 32.3077 9.61539H28.976C28.1724 12.4566 25.5601 14.5385 22.4616 14.5385H17.5385C14.44 14.5385 11.8277 12.4566 11.0241 9.61539ZM17.5385 4.69231C15.8391 4.69231 14.4616 6.06989 14.4616 7.76923C14.4616 9.46857 15.8391 10.8462 17.5385 10.8462H22.4616C24.1609 10.8462 25.5385 9.46857 25.5385 7.76923C25.5385 6.06989 24.1609 4.69231 22.4616 4.69231H17.5385Z",
    fill: "#C8BCFF",
    stroke: "#C8BCFF",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeLists);
export default __webpack_public_path__ + "static/media/large_lists.4d3db3d1618216eab4ae14b677cddd84.svg";
export { ForwardRef as ReactComponent };